import aderantTheme from "../Theme/AderantTheme";
export function getGridRowStyles(props) {
    const { isRowReadOnly, focusedRowId, row, rowPropsClassName } = props;
    const styles = gridStyles();
    const rowStyles = {
        ...styles.row,
        ...(row.canExpand ? styles.groupedRow : {}),
        ...(row.id === focusedRowId ? styles.focusedRow : {}),
        ...(isRowReadOnly ? styles.readOnlyRow : {}),
        ...(rowPropsClassName && { className: rowPropsClassName })
    };
    return rowStyles;
}
export function getGridRowClasses(props) {
    const { isRowReadOnly, defaultRowClasses, focusedRowId, row, rowPropsClassName } = props;
    const rowClasses = [...defaultRowClasses, "grid-row"];
    if (row.canExpand) {
        rowClasses.push(`grid-row-grouped`);
    }
    if (rowPropsClassName) {
        rowClasses.push(rowPropsClassName);
    }
    if (row.id == focusedRowId) {
        rowClasses.push(`grid-row-focused focused-row`);
    }
    if (isRowReadOnly) {
        rowClasses.push(`grid-row-readonly`);
    }
    return rowClasses;
}
export const gridStyles = () => {
    return {
        expander: {
            display: "inline-flex",
            alignItems: "center"
        },
        row: {
            backgroundColor: aderantTheme.palette.background.white
        },
        readOnlyRow: {
            WebkitTextFillColor: aderantTheme.palette.text.disabled,
            color: aderantTheme.palette.text.disabled
        },
        groupedRow: {
            backgroundColor: aderantTheme.palette.controls.grid.rowGroup.backgroundColor,
            color: aderantTheme.palette.text.primary,
            fontSize: "1.15em",
            width: "100% !important"
        },
        focusedRow: {
            backgroundColor: aderantTheme.palette.background.focus,
            boxShadow: `0px -1px 0px 0px ${aderantTheme.palette.border.focus}`,
            borderBottom: `1px solid ${aderantTheme.palette.border.focus}`
        },
        groupedCell: {
            paddingLeft: "0.3em",
            display: "flex"
        },
        lastCell: {
            flexGrow: 2
        },
        resizeHandle: {
            cursor: "col-resize",
            zIndex: 100,
            opacity: 1,
            height: "100%",
            top: "0%",
            right: 0,
            width: 5,
            minWidth: 5,
            borderRight: `1px solid ${aderantTheme.palette.primary.contrastText}`,
            marginLeft: "auto"
        },
        sortIcon: {
            verticalAlign: "middle",
            opacity: 0
        },
        sortIconAsc: {
            opacity: 1,
            transform: "rotate(-90deg)"
        },
        sortIconDesc: {
            opacity: 1,
            transform: "rotate(90deg)"
        },
        table: {
            overflowX: "auto"
        }
    };
};
